import { fetch } from 'libs/fetch';

export async function generateCorpJSSDKSignature(agentId, url) {
  const res = await fetch(`/api/ifs/v1/qywx/generateCorpJSSDKSignature?agentId=${agentId}`, {
    method: 'POST',
    json: {
      url,
    },
    //   wantError: true,
  });
  return res;
}

export async function generateAppJSSDKSignature(agentId, url) {
  const res = await fetch(`/api/ifs/v1/qywx/generateAppJSSDKSignature?agentId=${agentId}`, {
    method: 'POST',
    json: {
      url,
    },
    //   wantError: true,
  });
  return res;
}

/**
 * 拿微信jssdk初始化需要的配置
 */
export async function getWxSdkConfig(url: string) {
  const res = await fetch(`/api/ifs/v1/wx/generateJSSDKSignature`, {
    method: 'POST',
    json: { url },
  });
  return res;
}

export async function wxMpBindForLoginUser(appId, code) {
  const res = await fetch(`/api/ifs/v1/wx/wxMpBindForLoginUser?appId=${appId}&code=${code}`, {
    method: 'POST',
    json: {},
  });
  return res;
}
